import { render, staticRenderFns } from "./GSchoolClassesDraggable.vue?vue&type=template&id=026cd7b0&"
import script from "./GSchoolClassesDraggable.vue?vue&type=script&lang=ts&"
export * from "./GSchoolClassesDraggable.vue?vue&type=script&lang=ts&"
import style0 from "./GSchoolClassesDraggable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports